'use client';

import { Education } from "@/types/career";
import { GraduationCap, Pencil, Trash2 } from "lucide-react";

export function EducationCard({ item, onEdit, onDelete }: { item: Education; onEdit: () => void; onDelete: () => void }) {
  return (
    <div className="group global-border-radius border border-brand-bg/[0.08] bg-white hover:border-brand-bg/20 transition-all duration-200 px-5 py-4 flex items-center gap-4">
      <div className="h-10 w-10 flex-shrink-0 global-border-radius ring-1 ring-brand-bg/20 bg-brand-bg/[0.04] flex items-center justify-center">
        <GraduationCap className="h-5 w-5 text-brand-bg/50" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-brand-bg truncate">{item.degree} in {item.major}</p>
        <p className="text-xs text-gray-600 mt-0.5">{item.university}{item.GPA ? ` · GPA ${item.GPA}` : ""}</p>
      </div>
      <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button onClick={onEdit} className="p-1.5 global-border-radius bg-brand-bg/[0.05] hover:bg-brand-bg/[0.1] text-brand-bg/40 hover:text-brand-bg transition-colors">
          <Pencil className="h-3.5 w-3.5" />
        </button>
        <button onClick={onDelete} className="p-1.5 global-border-radius bg-brand-bg/[0.05] hover:bg-red-50 text-brand-bg/40 hover:text-red-500 transition-colors">
          <Trash2 className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
